// Schemas are populated as each section is implemented.
// Stub exports allow theme registration without TypeScript errors.

import { tailorSchemas } from '../../../tailor'
import { footwear1Fit } from './section-fit'
import { schema as accountSchema } from './sections/account/account.schema'
import { schema as signinSchema } from './sections/auth/signin.schema'
import { schema as signupSchema } from './sections/auth/signup.schema'
import { schema as bannerSchema } from './sections/banner/banner.schema'
import { schema as cartSchema } from './sections/cart/cart.schema'
import { schema as categoriesSchema } from './sections/categories/categories.schema'
import { schema as categorySchema } from './sections/category/category.schema'
import { schema as checkoutSchema } from './sections/checkout/checkout.schema'
import { schema as contactSchema } from './sections/contact/contact.schema'
import { schema as contentSchema } from './sections/content/content.schema'
import { schema as featuredCategorySchema } from './sections/featured-category/featured-category.schema'
import { schema as floatingButtonsSchema } from './sections/floating-buttons/floating-buttons.schema'
import { schema as footerSchema } from './sections/footer/footer.schema'
import { schema as headerSchema } from './sections/header/header.schema'
import { schema as heroSchema } from './sections/hero/hero.schema'
import { schema as orderSuccessSchema } from './sections/order-success/order-success.schema'
import { schema as productDetailSchema } from './sections/product/product-detail.schema'
import { schema as mobileNavSchema } from './sections/shared/mobile-nav.schema'
import { schema as similarProductsSchema } from './sections/shared/similar-products.schema'
import { schema as shopGridSchema } from './sections/shop/shop-grid.schema'
import { schema as wishlistSchema } from './sections/wishlist/wishlist.schema'
import { schema as announcementBarSchema } from './sections/announcement-bar/announcement-bar.schema'
import { schema as flashSaleSchema } from './sections/flash-sale/flash-sale.schema'
import { schema as newArrivalsSchema } from './sections/new-arrivals/new-arrivals.schema'
import { schema as offerBannerSchema } from './sections/offer-banner/offer-banner.schema'
import { schema as lookbookBannerSchema } from './sections/lookbook-banner/lookbook-banner.schema'
import { schema as instagramFeedSchema } from './sections/instagram-feed/instagram-feed.schema'
import { schema as blogSchema } from './sections/blog/blog.schema'
import { schema as featuresSchema } from './sections/features/features.schema'
import { schema as testimonialsSchema } from './sections/testimonials/testimonials.schema'
import { schema as ctaSchema } from './sections/cta/cta.schema'
import { schema as brandsSchema } from './sections/brands/brands.schema'
import { schema as productSliderSchema } from './sections/product-slider/product-slider.schema'
import { schema as productGridSchema } from './sections/product-grid/product-grid.schema'
import { schema as compareSchema } from './sections/compare/compare.schema'
import { schema as couponSchema } from './sections/coupon/coupon.schema'
import { schema as recentProductsSchema } from './sections/recent-products/recent-products.schema'

import { jutaSchemas } from './sections/jt'

const footwear1BaseSchemas = {
  componentSchemas: {
    account: accountSchema,
    signin: signinSchema,
    signup: signupSchema,
    banner: bannerSchema,
    cart: cartSchema,
    categories: categoriesSchema,
    category: categorySchema,
    checkout: checkoutSchema,
    contact: contactSchema,
    content: contentSchema,
    'featured-category': featuredCategorySchema,
    hero: heroSchema,
    'order-success': orderSuccessSchema,
    'product-detail': productDetailSchema,
    'similar-products': similarProductsSchema,
    'shop-grid': shopGridSchema,
    wishlist: wishlistSchema,
    'announcement-bar': announcementBarSchema,
    'flash-sale': flashSaleSchema,
    'new-arrivals': newArrivalsSchema,
    'offer-banner': offerBannerSchema,
    'lookbook-banner': lookbookBannerSchema,
    'instagram-feed': instagramFeedSchema,
    blog: blogSchema,
    features: featuresSchema,
    testimonials: testimonialsSchema,
    cta: ctaSchema,
    brands: brandsSchema,
    'product-slider': productSliderSchema,
    'product-grid': productGridSchema,
    compare: compareSchema,
    coupon: couponSchema,
    'recent-products': recentProductsSchema,
  },
  headerSchema,
  footerSchema,
  floatingButtonsSchema,
  mobileNavSchema,
}

/** Juta: the base schemas plus the fields its own markup reads (sections/ud). */
export const footwear1Schemas = tailorSchemas({
  ...footwear1BaseSchemas,
  componentSchemas: { ...footwear1BaseSchemas.componentSchemas, ...jutaSchemas.componentSchemas },
  ...jutaSchemas.chrome,
}, footwear1Fit)
